module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/company/company.component.css
// module id = ./src/app/company/company.component.css
// module chunks = main